export class BreadCrumbMenuItem {
   constructor(linkText: string, linkRoute: string) {
      this.LinkText = linkText;
      this.LinkRoute = linkRoute;
   }
   LinkText: string;
   LinkRoute: string;
}